<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text sync-success-dialog__title">
      <h2>{{ 'settings.integration.syncSuccess.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="success-info">
      <div class="checkmark-circle">
        <div class="background"></div>
        <div class="checkmark"></div>
      </div>
      <p>{{ 'settings.integration.syncSuccess.message' | translate }}</p>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'settings.integration.syncSuccess.close' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="goToEmployees()">
      <mat-icon>people</mat-icon>
      {{ 'settings.integration.syncSuccess.goToEmployees' | translate }}
    </button>
  </footer>
</div>
